export const getKeyByValue =(object, value) => {
    return object && (Object.keys(object).filter(key => object[key] === value)).toString();
}

export const getSelectedModel = (vehicleModels, value) => {
    return vehicleModels && Object.keys(vehicleModels.vehicles).find(
        (modelKey) => vehicleModels.vehicles[modelKey] === value);
};